/**
 * Blueprint for the Date object.
 */
export class DateObject {
  public date: Date;
  public format: string;

  public constructor(date: string, format: string) {
    this.date = date ? new Date(date) : null;
    this.format = format;
  }

  get dateIso(): string {
    if (this.date) {
      const localDate = new Date(this.date.getTime() - this.date.getTimezoneOffset() * 60 * 1000);
      localDate.setMilliseconds(0);
      localDate.setSeconds(0);
      return localDate.toISOString().slice(0, -1);
    } else {
      return null;
    }
  }
}
